<template>
  <div class="left_nav">
    <el-menu
      :default-active="defaultActiveMenuIndex"
      :collapse="isCollapse"
      class="el-menu-vertical-demo">
      <!--<el-menu-item index="1" @click="toNewRouter('message-over-view')" >-->
        <!--<i class="el-icon-damai-shujulaiyuan" style="font-size: 16px;"></i>-->
        <!--<span slot="title">概览</span>-->
      <!--</el-menu-item>-->
      <el-menu-item index="2" @click="toNewRouter('message-template-manage')" v-if="permissionCodes.indexOf('006001000') !== -1">
        <i class="el-icon-damai-moban1"></i>
        <span slot="title">消息模板</span>
      </el-menu-item>
      <el-menu-item index="4" @click="toNewRouter('message-push-config')" v-if="permissionCodes.indexOf('006002000') !== -1">
        <i class="el-icon-damai-shezhi"></i>
        <span slot="title">消息推送配置</span>
      </el-menu-item>
      <el-menu-item index="3" @click="toNewRouter('message-sed-manage')" v-if="permissionCodes.indexOf('006003000') !== -1">
        <i class="el-icon-s-promotion"></i>
        <span slot="title">消息推送记录</span>
      </el-menu-item>
      <el-menu-item index="5" @click="toNewRouter('message-log')" v-if="permissionCodes.indexOf('006004000') !== -1">
        <i class="el-icon-damai-ic_caozuorizhi"></i>
        <span slot="title">操作日志</span>
      </el-menu-item>

      <!-- <div style="line-height: 50px;display: flex;justify-content: flex-start;align-items: center;padding-left: 25px;">
        <i class="el-icon-s-fold" style="font-size: 24px;color: #00a0e6;cursor: pointer;" @click="isCollapse = true" v-if="!isCollapse"></i>
        <i class="el-icon-s-unfold" style="font-size: 24px;color: #00a0e6;cursor: pointer;" @click="isCollapse = false" v-if="isCollapse"></i>
      </div> -->
    </el-menu>
  </div>
</template>

<script>
import navMixin from "../../utils/nav";
import { bus } from "../../utils/bus";

const indexOfRouterNameEntities = Object.entries({
  1: "message-over-view",
  2: [
    "message-template-manage",
    "message-template-add",
    "message-template-modify",
  ],
  3: ["message-sed-manage"],
  4: ["message-push-config", "message-push-modify", "message-push-add"],
  5: "message-log",
});

export default {
  name: "epidemic-situation-nav",
  mixins: [navMixin],
  computed: {
    defaultActiveMenuIndex() {
      const { name: routeName } = this.$route;
      const entity = indexOfRouterNameEntities.find(([, routeNames]) => {
        if (routeNames instanceof Array) {
          return routeNames.indexOf(routeName) >= 0;
        } else {
          return routeNames === routeName;
        }
      });
      return entity && entity[0];
    },
  },
  data() {
    return {
      isCollapse: false,
      permissionCodes: "",
      indexOfRouterNameEntities,
    };
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes;
  },
  mounted() {
    bus.vue.$on("changeIsCollapse", (data) => {
      this.isCollapse = data;
    });
  },
  methods: {
    toNewRouter(name) {
      this.$router.push({
        name: name,
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../components/CommonStyle/commonNavStyle";
</style>



// WEBPACK FOOTER //
// src/view/MessageService/MessageNav.vue